exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cms-media-library__directory[data-v-37615bb8]{font-size:1.5rem;margin:1rem;flex:1 1 calc(20% - 2rem)}.cms-media-library__directory>span[data-v-37615bb8]{cursor:pointer;color:#585858}.cms-media-library__directory>span>.fa[data-v-37615bb8]{margin-right:5px}.cms-media-library__directory>span[data-v-37615bb8]:hover{color:#898989}", ""]);

// exports
